import {get,post} from '../utils/request';
// 游泳报名
export const addSwimming = params=>post('/match/sign/addSwim',params)
// 游泳报名修复
export const updateSwimming = params=>post('/match/sign/updateSwim',params)